import React from 'react';
import Hero from '../components/sections/Hero';
import Benefits from '../components/sections/Benefits';
import WhyNow from '../components/sections/WhyNow';
import Features from '../components/sections/Features';
import WhoIsItFor from '../components/sections/WhoIsItFor';
import About from '../components/sections/About';
import Contact from '../components/sections/Contact';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Benefits />
      <WhyNow />
      <Features />
      <WhoIsItFor />
      <About />
      <Contact />
    </>
  );
};

export default Home;
